"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Helper functions for consent management
function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

// Function to set gtag consent based on the CookieConsent cookie
function setGtagConsentFromCookie() {
  var cookieConsent = getCookie("CookieConsent");
  if (cookieConsent) {
    try {
      var consent = JSON.parse(decodeURIComponent(cookieConsent));
      typeof gtag === "function" && gtag("consent", "update", {
        ad_storage: consent.marketing ? "granted" : "denied",
        ad_user_data: consent.marketing ? "granted" : "denied",
        ad_personalization: consent.marketing ? "granted" : "denied",
        analytics_storage: consent.statistics ? "granted" : "denied"
      });
    } catch (e) {
      console.error("Error parsing CookieConsent cookie: ", e);
    }
  } else {
    // Set default consent to 'denied' if the cookie is not found
    typeof gtag === "function" && gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied"
    });
    window.showCookieBanner = true;
  }
}
var consentGranted = function consentGranted(parameter) {
  typeof gtag === "function" && gtag("consent", "update", _defineProperty({}, parameter, "granted"));
};
var consentDenied = function consentDenied(parameter) {
  typeof gtag === "function" && gtag("consent", "update", _defineProperty({}, parameter, "denied"));
};

// Function to set the preference cookie
var setPreferenceCookie = function setPreferenceCookie(preferences, statistics, marketing) {
  var consentData = JSON.stringify({
    necessary: true,
    preferences: preferences,
    statistics: statistics,
    marketing: marketing,
    timestamp: Date.now(),
    ver: 1
  });
  var expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = "CookieConsent=".concat(consentData, "; expires=").concat(expires, "; path=/");
};

// Function to toggle cookie consent box visibility
var setCookieboxVisible = function setCookieboxVisible(visible) {
  var cookieConsentBox = document.querySelector("#cookieConsentBox");
  if (!cookieConsentBox) {
    console.error("Couldn't find cookie consent box");
    return;
  }
  cookieConsentBox.classList.toggle("not-visible", !visible);
};

// Function to switch tabs in the cookie consent box
var switchTab = function switchTab(tabName) {
  var cookieConsentBox = document.querySelector("#cookieConsentBox");
  if (!cookieConsentBox) {
    console.error("Couldn't find cookie consent box");
    return;
  }
  var tabs = cookieConsentBox.querySelectorAll(".tabs > a");
  if (!tabs.length) {
    console.error("Couldn't find cookie consent tabs");
    return;
  }
  tabs.forEach(function (tab) {
    tab.setAttribute("aria-selected", tab.dataset.target === tabName ? "true" : "false");
  });
  var tabBodies = cookieConsentBox.querySelectorAll("div[data-target]");
  if (!tabBodies.length) {
    console.error("Couldn't find cookie consent tab bodies");
    return;
  }
  tabBodies.forEach(function (tabBody) {
    tabBody.classList.toggle("hidden", tabBody.dataset.target !== tabName);
    tabBody.classList.toggle("flex", tabBody.dataset.target == tabName);
  });
};

// Initialize cookie consent box functionality
(function () {
  setGtagConsentFromCookie();
  var cookieConsentBox = document.querySelector("#cookieConsentBox");
  if (!cookieConsentBox) {
    console.error("Couldn't find cookie consent box");
    return;
  }
  var tabs = cookieConsentBox.querySelectorAll(".tabs > a");
  if (!tabs.length) {
    console.error("Couldn't find cookie consent tabs");
    return;
  }
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      switchTab(tab.dataset.target);
    });
  });
  cookieConsentBox.querySelectorAll(".detail-btn").forEach(function (detailExpander) {
    detailExpander.addEventListener("click", function (e) {
      e.preventDefault();
      var bodyTarget = cookieConsentBox.querySelector("#" + detailExpander.getAttribute("data-target"));
      if (!bodyTarget) {
        console.error("Couldn't find detailExpander: ".concat(detailExpander.getAttribute("data-target")));
        return;
      }
      bodyTarget.classList.toggle("hidden");
      bodyTarget.classList.toggle("flex");
    });
  });
  var buttonsContainer = cookieConsentBox.querySelector(".cookie-buttons");
  if (!buttonsContainer) {
    console.error("Couldn't find cookie button container");
    return;
  }
  var allowPreferences = cookieConsentBox.querySelector("#allowPreferences");
  var allowStatistics = cookieConsentBox.querySelector("#allowStatistics");
  var allowMarketing = cookieConsentBox.querySelector("#allowMarketing");
  var allowNecessaryButton = buttonsContainer.querySelector("#allowNecessaryButton");
  var allowSelectedButton = buttonsContainer.querySelector("#allowSelectedButton");
  var allowAllButton = buttonsContainer.querySelector("#allowAllButton");
  var handleConsent = function handleConsent(preferences, statistics, marketing) {
    window.consent = {
      allowPreferences: preferences,
      allowStatistics: statistics,
      allowMarketing: marketing
    };
    allowPreferences.checked = preferences;
    allowStatistics.checked = statistics;
    allowMarketing.checked = marketing;
    statistics ? consentGranted("analytics_storage") : consentDenied("analytics_storage");
    marketing ? consentGranted("ad_storage") : consentDenied("ad_storage");
    marketing ? consentGranted("ad_user_data") : consentDenied("ad_user_data");
    marketing ? consentGranted("ad_personalization") : consentDenied("ad_personalization");
    var map = document.querySelector(".map");
    if (map) {
      map.classList.toggle("allowed", marketing);
      if (map.classList.contains("allowed") && isElementInViewport(map)) {
        loadMap(map.querySelector("iframe"));
      }
    }
    if (statistics) {
      if (typeof Bugsnag !== "undefined") {
        Bugsnag.startSession();
        Bugsnag.leaveBreadcrumb("User consented to tracking (statistics)", {
          type: "state"
        });
      }
    } else {
      window.settings.bugsnagOptions = {
        autoTrackSessions: false,
        collectUserIp: false,
        generateAnonymousId: false,
        enabledBreadcrumbTypes: ["error", "manual"]
      };
    }
    setPreferenceCookie(preferences, statistics, marketing);
    setCookieboxVisible(false);
  };
  allowNecessaryButton.addEventListener("click", function () {
    handleConsent(false, false, false);
  });
  allowSelectedButton.addEventListener("click", function () {
    handleConsent(allowPreferences.checked, allowStatistics.checked, allowMarketing.checked);
  });
  allowAllButton.addEventListener("click", function () {
    handleConsent(true, true, true);
  });
  buttonsContainer.querySelectorAll("button").forEach(function (button) {
    button.disabled = false;
  });
  if (window.showCookieBanner !== undefined && window.showCookieBanner == true) {
    setCookieboxVisible(true);
  }
})();
//# sourceMappingURL=cookies.js.map